/* GENERATED FILE */
import type { ReactElement, FC } from 'react';
import { Path } from 'react-native-svg';
import { type IconWeight } from '../lib';

export default new Map<
  IconWeight,
  ReactElement | FC<{ duotoneColor?: string; duotoneOpacity?: number }>
>([
  [
    'bold',
    <>
      <Path d="M195.8 60.2a28 28 0 0 0-39.51-.09l-11.61 12.17a12 12 0 1 1-17.36-16.56L139 43.43l.2-.2a52 52 0 0 1 73.54 73.54l-.2.2-12.29 11.71a12 12 0 0 1-16.56-17.36l12.17-11.61a28 28 0 0 0-.06-39.51m-84.48 123.52-11.61 12.17a28 28 0 0 1-39.6-39.6l12.17-11.61a12 12 0 0 0-16.56-17.36L43.43 139l-.2.2a52 52 0 0 0 73.54 73.54l.2-.2 11.71-12.29a12 12 0 1 0-17.36-16.56ZM216 148h-24a12 12 0 0 0 0 24h24a12 12 0 0 0 0-24M40 108h24a12 12 0 0 0 0-24H40a12 12 0 0 0 0 24m120 72a12 12 0 0 0-12 12v24a12 12 0 0 0 24 0v-24a12 12 0 0 0-12-12M96 76a12 12 0 0 0 12-12V40a12 12 0 0 0-24 0v24a12 12 0 0 0 12 12" />
    </>,
  ],
  [
    'duotone',
    ({
      duotoneColor,
      duotoneOpacity,
    }: {
      duotoneColor?: string;
      duotoneOpacity?: number;
    }) => (
      <>
        <Path
          d="m204.28 108.28-96 96a40 40 0 0 1-56.56-56.56l96-96a40 40 0 0 1 56.56 56.56"
          opacity={duotoneOpacity}
          fill={duotoneColor}
        />
        <Path d="M198.63 57.37a32 32 0 0 0-45.19-.06l-11.65 12.21a8 8 0 0 1-11.58-11l11.72-12.29a2 2 0 0 1 .13-.13 48 48 0 0 1 67.88 67.88 2 2 0 0 1-.13.13l-12.29 11.72a8 8 0 0 1-11-11.58l12.21-11.65a32 32 0 0 0-.1-45.23m-84.42 129.11-11.65 12.21a32 32 0 0 1-45.25-45.25l12.21-11.65a8 8 0 0 0-11-11.58l-12.33 11.72a2 2 0 0 0-.13.13 48 48 0 0 0 67.88 67.88 2 2 0 0 0 .13-.13l11.72-12.29a8 8 0 1 0-11.58-11ZM216 152h-24a8 8 0 0 0 0 16h24a8 8 0 0 0 0-16M40 104h24a8 8 0 0 0 0-16H40a8 8 0 0 0 0 16m120 80a8 8 0 0 0-8 8v24a8 8 0 0 0 16 0v-24a8 8 0 0 0-8-8M96 72a8 8 0 0 0 8-8V40a8 8 0 0 0-16 0v24a8 8 0 0 0 8 8" />
      </>
    ),
  ],
  [
    'fill',
    <>
      <Path d="M208 32H48a16 16 0 0 0-16 16v160a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16M96 64a8 8 0 0 1 16 0v16a8 8 0 0 1-16 0ZM64 96h16a8 8 0 0 1 0 16H64a8 8 0 0 1 0-16m64.08 85.66-7.21 7.21a38 38 0 1 1-53.74-53.74l7.21-7.21a8 8 0 1 1 11.32 11.31l-7.22 7.21a22 22 0 0 0 31.12 31.12l7.21-7.22a8 8 0 1 1 11.31 11.32M160 192a8 8 0 0 1-16 0v-16a8 8 0 0 1 16 0Zm32-32h-16a8 8 0 0 1 0-16h16a8 8 0 0 1 0 16m-3.13-39.13-7.21 7.21a8 8 0 1 1-11.32-11.31l7.22-7.21a22 22 0 0 0-31.12-31.12l-7.21 7.22a8 8 0 1 1-11.31-11.32l7.21-7.21a38 38 0 1 1 53.74 53.74" />
    </>,
  ],
  [
    'light',
    <>
      <Path d="M200 56a34 34 0 0 0-48-.05l-11.66 12.19a6 6 0 1 1-8.68-8.28l11.71-12.28.1-.11a46 46 0 0 1 65.06 65.06l-.11.1-12.28 11.71a6 6 0 1 1-8.28-8.68L200.09 104a34 34 0 0 0-.09-48m-84.38 131.9L104 200.09A34 34 0 0 1 55.91 152l12.23-11.67a6 6 0 0 0-8.28-8.68l-12.28 11.72-.11.1a46 46 0 0 0 65.06 65.06l.1-.11 11.71-12.28a6 6 0 1 0-8.68-8.28ZM216 154h-24a6 6 0 0 0 0 12h24a6 6 0 0 0 0-12M40 102h24a6 6 0 0 0 0-12H40a6 6 0 0 0 0 12m120 84a6 6 0 0 0-6 6v24a6 6 0 0 0 12 0v-24a6 6 0 0 0-6-6M96 70a6 6 0 0 0 6-6V40a6 6 0 0 0-12 0v24a6 6 0 0 0 6 6" />
    </>,
  ],
  [
    'regular',
    <>
      <Path d="M198.63 57.37a32 32 0 0 0-45.19-.06l-11.65 12.21a8 8 0 0 1-11.58-11l11.72-12.29a2 2 0 0 1 .13-.13 48 48 0 0 1 67.88 67.88 2 2 0 0 1-.13.13l-12.29 11.72a8 8 0 0 1-11-11.58l12.21-11.65a32 32 0 0 0-.1-45.23m-84.42 129.11-11.65 12.21a32 32 0 0 1-45.25-45.25l12.21-11.65a8 8 0 0 0-11-11.58l-12.33 11.72a2 2 0 0 0-.13.13 48 48 0 0 0 67.88 67.88 2 2 0 0 0 .13-.13l11.72-12.29a8 8 0 1 0-11.58-11ZM216 152h-24a8 8 0 0 0 0 16h24a8 8 0 0 0 0-16M40 104h24a8 8 0 0 0 0-16H40a8 8 0 0 0 0 16m120 80a8 8 0 0 0-8 8v24a8 8 0 0 0 16 0v-24a8 8 0 0 0-8-8M96 72a8 8 0 0 0 8-8V40a8 8 0 0 0-16 0v24a8 8 0 0 0 8 8" />
    </>,
  ],
  [
    'thin',
    <>
      <Path d="M201.46 54.54a36.06 36.06 0 0 0-50.92 0l-11.65 12.22a4 4 0 0 1-5.78-5.52L144.82 49a44 44 0 1 1 62.29 62.15l-12.35 11.78a4 4 0 0 1-5.52-5.78l12.28-11.72a36 36 0 0 0-.06-50.89m-84.35 134.7-11.65 12.22a36 36 0 0 1-51-50.85l12.28-11.72a4 4 0 0 0-5.52-5.78l-12.33 11.78A44 44 0 1 0 111.18 207l11.71-12.28a4 4 0 1 0-5.78-5.52ZM216 156h-24a4 4 0 0 0 0 8h24a4 4 0 0 0 0-8M40 100h24a4 4 0 0 0 0-8H40a4 4 0 0 0 0 8m120 88a4 4 0 0 0-4 4v24a4 4 0 0 0 8 0v-24a4 4 0 0 0-4-4M96 68a4 4 0 0 0 4-4V40a4 4 0 0 0-8 0v24a4 4 0 0 0 4 4" />
    </>,
  ],
]);
